import React from 'react'

import * as S from './flex.styled'
import type { FlexProps } from './flex.types'

export const Flex = ({
  direction,
  align,
  justify,
  wrap,
  gap,
  columnGap,
  rowGap,
  flex,
  grow,
  shrink,
  basis,
  padding,
  paddingX,
  paddingY,
  margin,
  marginX,
  marginY,
  children,
  ...rest
}: FlexProps) => {
  return (
    <S.Flex
      {...rest}
      $direction={direction}
      $align={align}
      $justify={justify}
      $wrap={wrap}
      $gap={gap}
      $columnGap={columnGap}
      $rowGap={rowGap}
      $flex={flex}
      $grow={grow}
      $shrink={shrink}
      $basis={basis}
      $padding={padding}
      $paddingX={paddingX}
      $paddingY={paddingY}
      $margin={margin}
      $marginX={marginX}
      $marginY={marginY}
      data-component-id="Flex"
    >
      {children}
    </S.Flex>
  )
}
